<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import request from "./utils/request";

  export default {
    name: "App",
    data() {
      return {};
    },
    methods: {
    },
    mounted() {
        request({
            url: "/Insurance/info/getAmountReceived",
            method: "GET"
        }).then(r => {
            const {code, data} = r.data || {};
            if (code == 2000) {
                this.$store.commit('updateViewCount', data)
            }
        });
    }
  };
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
  }
  html,body,ul,li,p,span,div {
    margin: 0;
    padding: 0;
  }
</style>
